import { Body } from "@hypercard/web-components";
import { Chart, DateRangePicker, TopListChart } from "../components";
import { StatCard } from "./StatCard";
import { IconBox } from "@common/components";
import { Airplane } from "@phosphor-icons/react";
import { useHomeTabInputs } from "./useHomeTabInputs";
import { ChartCard } from "./ChartCard";
import {
  ExpensePolicyStatus,
  ExpenseReportAnalyticGroup,
  ExpenseStatus,
  GraphAnalyticInterval,
} from "@common/utils/graphql";

export const HomeTab = () => {
  const { dateRange, upsert } = useHomeTabInputs();

  return (
    // TODO: replace this with a drag-drop interface
    <div className="grid grid-cols-2 gap-4">
      {/* Inputs */}
      <div className="col-span-full flex">
        <DateRangePicker
          dateRange={dateRange}
          onChange={(dateRange) => upsert({ dateRange })}
          showLabel={false}
        />
      </div>

      {/* TODO: remove this (just for demo) */}
      <div className="col-span-full grid grid-cols-4 gap-4">
        <StatCard
          headerText="TOTAL SPEND"
          primaryText="$27,450.75"
          percentageChange="19%"
          subText="vs last 30 days"
        />
        <StatCard
          headerText="TOTAL REIMBURSED"
          primaryText="$12,232.32"
          percentageChange="19%"
          subText="vs last 30 days"
        />
        <StatCard
          headerText="MOST USED STIPEND"
          primaryText="Travel Stipend"
          icon={
            <IconBox className="mb-1">
              <Airplane className="size-6 rotate-45" />
            </IconBox>
          }
          subText="$8,793.78 Reimbursed in last 30 days"
        />
        <StatCard
          headerText="MOST USED PERK"
          primaryText="TSA PreCheck"
          icon={
            <img
              src="https://assets.development.hypercard.com/benefits/tsa_precheck.png"
              className="h-10 w-10 rounded"
            />
          }
          subText="$778.35 Redeemed in last 30 days"
        />
        <StatCard
          headerText="HYPERCARD HYBRID"
          primaryText="32 Issued"
          percentageChange="19%"
          subText="vs last 30 days"
        />
        <StatCard
          headerText="HYPERCARD BUSINESS"
          primaryText="8 Issued"
          percentageChange="19%"
          subText="vs last 30 days"
        />
        <StatCard
          headerText="TOP USERS"
          primaryText="Marc Baghadjian"
          icon={
            <div className="flex h-8 w-8 items-center justify-center rounded-full border border-white/10 bg-white/15">
              <Body size="xs" weight="regular">
                MB
              </Body>
            </div>
          }
          subText="8 expenses last 30 days"
        />
        <StatCard
          headerText="TOP DEPARTMENT"
          primaryText="Operations"
          subText="27 expenses last 30 days"
        />
      </div>

      {/* Total Spend */}
      <ChartCard headerText="TOTAL SPENDING">
        <Chart
          query={{
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            queryType: "report",
            reportProps: {
              groupedBy: ExpenseReportAnalyticGroup.PaymentMethod,
              expenseStatus: [ExpenseStatus.Approved],
            },
          }}
          className="mt-6"
        />
      </ChartCard>

      {/* Stipend Utilization */}
      <ChartCard headerText="SPENDING BY EMPLOYEE">
        <Chart
          query={{
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            queryType: "report",
            reportProps: {
              groupedBy: ExpenseReportAnalyticGroup.Employee,
              expenseStatus: [ExpenseStatus.Approved],
            },
          }}
          className="mt-6"
        />
      </ChartCard>

      {/* Flagged Spenders */}
      <ChartCard headerText="OUT OF POLICY EXPENSES (APPROVED)">
        <TopListChart
          headerText="Flagged Spenders"
          variables={{
            groupedBy: ExpenseReportAnalyticGroup.Employee,
            interval: GraphAnalyticInterval.Monthly,
            filters: {
              transactedAfter: dateRange.startDate,
              transactedBefore: dateRange.endDate,
              policyStatus: [
                ExpensePolicyStatus.OutOfPolicy,
                ExpensePolicyStatus.MissingInformation,
              ],
              expenseStatus: [ExpenseStatus.Approved],
            },
          }}
        />
      </ChartCard>

      {/* Flagged Approvers */}
      <ChartCard headerText="APPROVERS OF OUT OF POLICY EXPENSES">
        <TopListChart
          headerText="Flagged Approvers"
          variables={{
            groupedBy: ExpenseReportAnalyticGroup.Reviewer,
            interval: GraphAnalyticInterval.Monthly,
            filters: {
              transactedAfter: dateRange.startDate,
              transactedBefore: dateRange.endDate,
              policyStatus: [
                ExpensePolicyStatus.OutOfPolicy,
                ExpensePolicyStatus.MissingInformation,
              ],
              expenseStatus: [ExpenseStatus.Approved],
            },
          }}
        />
      </ChartCard>
    </div>
  );
};
